import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="add-form-fields"
export default class extends Controller {
  static targets = ["fieldsTemplate", "fields"]

  add(event) {
    event.preventDefault
    let dummy = new Date().getTime()
    // child_index: 'NEW_RECORD'  <--- should be in the fields_for
    let content = this.fieldsTemplateTarget.innerHTML.replace(/NEW_RECORD/g, dummy.toString())
    this.fieldsTarget.insertAdjacentHTML('beforeend', content)
  }
}
